/**
 * ErrorBoundary wrapper that automatically resets on route changes
 * Uses React Router v6 hooks
 */

import React from 'react'
import { useLocation } from 'react-router'
import { ErrorBoundary as BaseErrorBoundary, type ErrorBoundaryProps } from './ErrorBoundary'

export const ErrorBoundary: React.FC<Omit<ErrorBoundaryProps, 'location'>> = ({
  children,
  ...props
}) => {
  const location = useLocation()

  return (
    <BaseErrorBoundary {...props} location={location}>
      {children}
    </BaseErrorBoundary>
  )
}
